const MIN_EDGE_ZONE = 48;
const MAX_EDGE_ZONE = 96;
const MIN_SPEED = 180;
const MAX_SPEED = 900;

export function kanbanEdgeScrollVelocity({
  pointerX,
  containerLeft,
  containerRight,
  canScrollLeft,
  canScrollRight,
}: {
  pointerX: number;
  containerLeft: number;
  containerRight: number;
  canScrollLeft: boolean;
  canScrollRight: boolean;
}) {
  const width = containerRight - containerLeft;
  if (width <= 0) return 0;

  const edgeZone = Math.min(MAX_EDGE_ZONE, Math.max(MIN_EDGE_ZONE, width * 0.15));
  const leftLimit = containerLeft + edgeZone;
  const rightLimit = containerRight - edgeZone;

  if (canScrollLeft && pointerX < leftLimit) {
    const strength = Math.min(1, Math.max(0, (leftLimit - pointerX) / edgeZone));
    return -(MIN_SPEED + (MAX_SPEED - MIN_SPEED) * strength * strength);
  }
  if (canScrollRight && pointerX > rightLimit) {
    const strength = Math.min(1, Math.max(0, (pointerX - rightLimit) / edgeZone));
    return MIN_SPEED + (MAX_SPEED - MIN_SPEED) * strength * strength;
  }
  return 0;
}
